module.exports = __webpack_public_path__ + "img/logo_WD.5a3f4a25.jpg";